Drupal.behaviors.drilldownNavigationDrupal = {
  // eslint-disable-next-line no-unused-vars
  attach() {
    const documentRoot = window
      .once('drilldownNavigationDrupal', document.querySelector('html'))
      .shift();

    if (documentRoot) {
      let isInitialEvent = true;
      let initialTeaserList = [];
      let initialListId = null;

      document.addEventListener('reactMenuUpdate', (props) => {
        const {
          detail: { nextStack },
        } = props;

        const currentList = nextStack[nextStack.length - 1];
        const { isInitialList, index: currentListIndex } = currentList;

        let teaserList = [];

        if (isInitialEvent) {
          // save initial list data
          for (let i = 0; i < 3; i++) {
            const node = document.querySelector(
              `.drilldown-navigation--teaser-${i +
                1} .drilldown-navigation--teaser-innerwrapper > *`
            );
            if (node) {
              initialTeaserList[i] = {
                id: node.getAttribute('data-id'),
                node,
              };
            } else {
              initialTeaserList[i] = {};
            }
          }
        }

        if (isInitialList) {
          initialListId = currentListIndex;
          teaserList = initialTeaserList;
        } else {
          // find next navigation Item that has teaser data (including ancestor items for inheritance)
          const navigationItem = [...nextStack]
            .map((el) => {
              if (el.index === initialListId && initialTeaserList.length) {
                el.data = { content: initialTeaserList };
              }
              return el;
            })
            .reverse()
            .find((el) => el.data && el.data.content);
          teaserList = navigationItem ? navigationItem.data.content : [];
        }

        // only loop through 3 teaser items, all others are ignored
        for (let i = 0; i < 3; i++) {
          const teaser = teaserList[i];

          const wrapper = document.querySelector(`.drilldown-navigation--teaser-${i + 1}`);
          // do nothing and prevent error if wrapper doesn't exist
          if (!wrapper) continue;
          const newNavigationTeaser = document.createElement('div');

          // save old Teasers for transition and deletion
          const oldTeasers = [...wrapper.children];

          // don't re-render if teaser id is the same as existing one
          if (teaser && oldTeasers[0] && oldTeasers[0].children[0]) {
            const oldteaserId = oldTeasers[0].children[0].getAttribute('data-id');
            if (oldteaserId && teaser.id && oldteaserId === teaser.id) {
              continue;
            }
          }

          // create new teaser element and add content if available
          newNavigationTeaser.classList.add(
            'drilldown-navigation--teaser-innerwrapper',
            'absolute',
            'top-0',
            'left-0',
            'w-full',
            'z-20'
          );
          if (teaser && teaser.content) {
            newNavigationTeaser.innerHTML = teaser.content;
          } else if (teaser && teaser.node) {
            newNavigationTeaser.appendChild(teaser.node);
          }
          // initiate fade in for teaser
          newNavigationTeaser.classList.add('opacity-0', 'transition-opacity', 'duration-500');
          wrapper.appendChild(newNavigationTeaser);
          setTimeout(() => {
            newNavigationTeaser.classList.remove('opacity-0');
          }, 0);

          // initiate fade out transition for old teasers
          oldTeasers.forEach((el) => {
            el.classList.add('z-10');
          });
          setTimeout(() => {
            oldTeasers.forEach((el) => {
              el.classList.add('transition-opacity', 'duration-500', 'opacity-0');
            });
          }, 100);

          // remove old teasers after transition is over
          setTimeout(() => {
            oldTeasers.forEach((el) => el.remove());
          }, 1000);
        }
        isInitialEvent = false;
        return;
      });
    }
  },
};

const forwardIcon = `<svg class="fill-current svg w-6 h-6"><use xlink:href="/themes/wingsuit/dist/app-drupal/images/spritemap.svg#chevron-right"></use></svg>`;
const backIcon = `<svg class="fill-current svg w-6 h-6"><use xlink:href="/themes/wingsuit/dist/app-drupal/images/spritemap.svg#arrow-left"></use></svg>`;

Drupal.theme.reactMenuIcons = (icon) => {
  switch (icon) {
    case 'forward':
      return forwardIcon;
    case 'back':
      return backIcon;
    default:
      return;
  }
};
